module.exports = __webpack_public_path__ + "static/img/img_gaode.d8dfe719.png";